<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <vue-tabs @tab-change="handleTabChange" ref="climateTabs">
          <v-tab
            v-for="mod in levelThree(7)"
            :key="mod.id"
            :title="translateDataBaseText(mod.name, mod.other_value)"
            :icon="mod.icon"
          >
          </v-tab>
          <router-view
            v-if="getMenuFromSessionStorage().length > 0"
            @showNotification="notifyVue"
            @cotentLoading="cotentLoading"
          ></router-view>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueTabs from 'vue-nav-tabs';
import MixinThirdLevel from 'src/util/mixinThirdLevel';
import MixinIndexTab from 'src/util/mixinIndexTab';
import MixinTranslate from 'src/util/mixinTranslate';

Vue.use(VueTabs);

export default {
  data() {
    return {
      activeName: 'first',
    };
  },

  mixins: [MixinThirdLevel, MixinIndexTab, MixinTranslate],

  updated() {
    this.setUpdated(this.$refs.climateTabs);
  },

  mounted() {
    this.setMounted(this.$refs.climateTabs);
  },

  destroyed() {
    this.setDestroyed();
  },
};
</script>
<style lang="scss">
// css transition for tabs
.vue-tabs .tab-content {
  .tab-container {
    animation: fadeIn 0.5s;
  }
}
</style>
